<template>
  <custom-popover ref="templateSynsPopover" class="template-syns-popover" :backdrop="true">
    <div class="popover-header">
      <div class="left-side-header">
        <h2>{{ $t("template-syns.title") }}</h2>
      </div>
      <div class="close-popover" @click.stop.prevent="onClose()">
        <i class="fa-light fa-times"></i>
      </div>
    </div>
    <div class="template-syns-wrapper">
      <div class="left custom-scrollbar-light">
        <div class="search-filter">
          <custom-input
            class="search-input synonym-filter"
            :inputType="'text'"
            :name="'templateSynonymSearch'"
            v-model="searchFilter"
            ref="synonymFilter"
            :label="$t('search') + ' ' + $t('template-syns.title')"
            :placeholder="$t('search') + '...'"
          />
          <div class="search-icon">
            <i class="fa-light fa-search"></i>
          </div>
        </div>

        <div class="template-syns-list" v-if="!showSyns">
          <div v-if="templateSyns == null || templateSyns.length == 0" class="no-syns">
            <span>{{ $t("template-syns.empty-list") }}</span>
          </div>
          <div
            v-if="(filteredSynonymList == null || filteredSynonymList.length == 0) && templateSyns.length > 0"
            class="no-syns"
          >
            <span>{{
              $t("template-syns.empty-list-search1") + searchFilter + $t("template-syns.empty-list-search2")
            }}</span>
          </div>
          <div
            class="template-syn"
            v-for="(templateSyn, index) in filteredSynonymList"
            :key="index"
            @click="(selectedSyn = filteredSynonymList[index]), (createSynClicked = false)"
            :class="{ 'is-selected': templateSyn == selectedSyn }"
          >
            <div class="flex-grow-1 ellipsis syn-name">
              <span>{{ templateSyn.name }}</span>
            </div>

            <div>
              <span
                class="duplicate-btn"
                @click="duplicateTemplateSynonym(templateSyn, index)"
                tooltip-placement="left"
                :tooltip="$t('duplicate')"
              >
                <i class="fa-light fa-clone"></i>
              </span>
              <span class="selected-chevron">
                <i class="fa-light fa-chevron-right"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <button
        class="btn btn-primary create-btn"
        @click="(createSynClicked = createSynClicked = true), (selectedSyn = null)"
      >
        {{ $t("template-syns.new-syn-btn") }}
      </button>
      <div class="right custom-scrollbar-light">
        <div v-if="createSynClicked" class="create-template-syn">
          <form @submit.stop.prevent>
            <custom-input
              :inputType="'text'"
              :pattern="'[a-zA-Z0-9]+'"
              v-model="newTemplateSyn"
              :name="'templateSynName'"
              :label="$t('template-syns.create-template-syn')"
              :placeholder="$t('template-syns.create-syn-placeholder')"
              :focusInputField="true"
            />
            <span v-if="invalidName" class="text-danger">
              {{ $t("template-syns.duplicate-name-err") }}
              <br />
            </span>
            <span v-if="!invalidChars" class="text-danger">
              {{ $t("template-syns.invalid-name-err") }}
              <br />
            </span>
            <button
              class="btn btn-primary"
              @click="createTemplateSyn"
              :disabled="newTemplateSyn == '' || invalidName || !invalidChars"
            >
              {{ $t("template-syns.create-btn") }}
            </button>
          </form>
        </div>
        <div v-if="selectedSyn" class="selected-syn">
          <!-- <h4>{{selectedSyn.name}}</h4> -->
          <div class="top">
            <custom-input
              class="disabled-name"
              v-if="!renaming"
              :inputType="'text'"
              v-model="selectedSyn.name"
              :name="'SynonymName'"
              :label="$t('template-syns.selected-syn-name')"
              isDisabled
            />

            <form v-else @submit.stop.prevent="renameSynonym" class="rename-form">
              <custom-input
                ref="editName"
                :inputType="'text'"
                v-model="newName"
                :name="'SynonymName'"
                :label="$t('template-syns.selected-syn-name')"
                :isDisabled="!renaming"
                :pattern="'[a-zA-Z0-9]+'"
              />
              <button
                v-show="renaming"
                :disabled="newName == '' || (!nameIsSelf && invalidName) || !invalidChars"
                class="btn checkmark"
                @click="renameSynonym"
              >
                <i class="fa-light fa-check"></i>
              </button>
              <span v-if="invalidName && !nameIsSelf" class="text-danger text-xs">
                {{ $t("template-syns.duplicate-name-err") }}
                <br />
              </span>
              <span v-if="!invalidChars" class="text-danger text-xs">
                {{ $t("template-syns.invalid-name-err") }}
                <br />
              </span>
            </form>

            <div class="delete-syn" @click="deletetemplateSyn">
              <i class="fa-light fa-trash"></i>
            </div>
            <div
              v-show="!renaming"
              class="rename-syn"
              @click="onRenameSynonym"
              :tooltip="$t('template-syns.edit-name')"
            >
              <i class="fa-light fa-pen"></i>
            </div>
          </div>
          <form @submit.stop.prevent class="new-synonym-form">
            <custom-input
              :inputType="'text'"
              v-model="newSynonym"
              :name="'createSynonyms'"
              :label="$t('template-syns.add-synonym')"
              :placeholder="$t('template-syns.add-synonym-label') + selectedSyn.name"
              :focusInputField="true"
            />
            <button
              v-if="newSynonym.length > 0"
              type="button"
              class="ai-synonyms btn btn-ai"
              @click="synonymSuggestions()"
              :tooltip="$t('suggest') + ` '${newSynonym}' '` + $t('variations')"
              tooltip-placement="left"
            >
              <i class="fa-light fa-plus"></i>
            </button>
            <button type="submit" class="new-synonym" @click="AddToSynonymGroup">+</button>
          </form>

          <div class="template-synonym-list-wrapper flex-grow-1 ellipsis">
            <div class="syn-instances-header">
              <span for="template-synonym-list">{{ $t("template-syns.list-label") }}{{ selectedSyn.name }}</span>

              <div class="actions">
                <button
                  v-if="synonymsTranslated && oldSynonyms.length > 0"
                  @click="undoTranslation()"
                  class="btn btn-undo"
                  :tooltip="$t('undo-translation')"
                  tooltip-placement="bottom-left"
                >
                  <span><i class="fa-light fa-undo"></i></span>
                </button>

                <button
                  @click="translateSynonymInstances(selectedSyn.synonyms)"
                  class="btn btn-ai"
                  :tooltip="`Translate to ${$store.state.aiTranslationLanguage}`"
                  tooltip-placement="bottom-left"
                >
                  <span> <i class="fa-light fa-language"></i></span>
                </button>
              </div>
            </div>

            <div
              v-for="(synonym, index) in selectedSyn.synonyms"
              :key="index"
              name="template-synonym-list"
              class="template-synonym-list"
            >
              <custom-input
                class="custom-input"
                @input="hasChanges = true"
                :inputType="'text'"
                v-model="selectedSyn.synonyms[index]"
                :name="'synonym-' + index"
                :class="{ 'is-translating': translatingSynonyms }"
              />
              <button class="trash-synonym" @click="deleteFromSynonymGroup(index)">
                <i class="fa-light fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </custom-popover>
</template>

<script>
import EventBus from "@/assets/js/eventBus.js";
import Template from "@/assets/js/template.js";
import CustomInput from "@/components/CustomInput";
import CustomPopover from "@/components/CustomPopover";
import ConfirmModal from "@/components/modals/ConfirmModal";
import orderBy from "lodash/orderBy";
export default {
  name: "templatetemplateSynsPopover",
  data() {
    return {
      createSynClicked: false,
      selectedSyn: null,
      loading: null,
      selectedTemplateVariable: null,
      hasChanges: false,
      showSyns: false,
      // invalid: false
      newTemplateSyn: "",
      newSynonym: "",
      // invalidName: false
      matchCounter: 0,
      searchFilter: "",
      renaming: false,
      newName: null,
      translatingSynonyms: false,
      oldSynonyms: [],
      synonymsTranslated: false,
      loadingSuggestions: false
    };
  },
  props: {
    template: {
      type: Object,
      required: true
    }
  },
  methods: {
    translateSynonymInstances(synonyms) {
      this.translatingSynonyms = true;
      this.$store
        .dispatch("translateAISynonyms", {
          synonyms: synonyms,
          translationLanguage: this.$store.state.aiTranslationLanguage
        })
        .then((res) => {
          this.oldSynonyms = Object.assign([], this.selectedSyn.synonyms);
          this.selectedSyn.synonyms = res;
          this.synonymsTranslated = true;
          this.$store.state.unsavedChanges = true;
        })
        .finally(() => {
          this.translatingSynonyms = false;
        });
    },

    undoTranslation() {
      this.selectedSyn.synonyms = this.oldSynonyms;
      this.synonymsTranslated = false;
    },

    synonymSuggestions() {
      this.loadingSuggestions = true;
      this.$store
        .dispatch("getSynonymSuggestions", this.newSynonym)
        .then((response) => {
          this.selectedSyn.synonyms = this.selectedSyn.synonyms.concat([this.newSynonym].concat(response));
          this.newSynonym = "";
          this.hasChanges = true;
          this.$store.state.unsavedChanges = true;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loadingSuggestions = false;
        });
    },

    synonymPattern(query) {
      return new RegExp(":gsyn\\(" + query + "(\\|[^\\)]+)?\\)", "g");
    },

    duplicateTemplateSynonym(templateSyn, index) {
      let newName = templateSyn.name;
      let i = 0;
      while (this.templateSyns.some((v) => v.name == newName)) {
        i++;
        newName = `${templateSyn.name} (${i})`;
      }

      const newTemplateSyn = { synonyms: [...templateSyn.synonyms], name: newName };
      const newIndex = index + 1;
      this.$store.state.template.globalSynonyms.splice(newIndex, 0, newTemplateSyn);
      this.selectedSyn = newTemplateSyn;
      this.$store.state.unsavedChanges = true;
    },

    createTemplateSyn() {
      const newSynonymData = {
        name: this.newTemplateSyn,
        synonyms: []
      };
      this.$store.state.template.globalSynonyms.push(newSynonymData);
      this.$store.state.unsavedChanges = true;
      this.$nextTick(() => {
        this.createSynClicked = false;
        this.selectedSyn = this.templateSyns[this.templateSyns.length - 1];
        this.newTemplateSyn = "";
      });
    },
    AddToSynonymGroup() {
      this.selectedSyn.synonyms.push(this.newSynonym);
      this.newSynonym = "";
      this.hasChanges = true;
      this.$store.state.unsavedChanges = true;
    },
    deleteFromSynonymGroup(index) {
      this.selectedSyn.synonyms.splice(index, 1);
    },
    handleSave() {
      EventBus.$emit("save-template-synonym");
      this.hasChanges = false;
    },
    editVariable(index) {
      this.selectedSyn = this.templateSyns[index];
    },
    updatetemplateSyn() {
      let synToUpdate = this.templateSyns.findIndex((v) => v.name == this.selectedSyn.name);
      this.$set(this.templateSyns, synToUpdate, this.selectedSyn);
      this.$store.state.unsavedChanges = true;
      this.updatePreview();
    },
    onClose() {
      this.$emit("close");
    },
    deletetemplateSyn() {
      this.searchTemplate();
      this.$modal.show(
        ConfirmModal,
        {
          title: this.$t("template-syns.delete-title"),
          //   description: this.$t("template-syns.delete-desc") + `${this.selectedSyn.name}?`,
          description:
            this.selectedSyn.name +
            this.$t("template-syns.delete-desc-1") +
            this.matchCounter +
            this.$t("template-syns.delete-desc-2"),
          confirmButtonText: this.$t("delete"),
          onConfirm: (result) => {
            const query = this.selectedSyn.name;
            const pattern = this.synonymPattern(query);
            this.$store.commit("transformTemplateSynonyms", { synonym: this.selectedSyn, pattern: pattern });
            if (this.$store.state.sentenceBeingEdited) {
              this.$store.commit("transformTemplateSynonymsInCurrentSection", {
                synonym: this.selectedSyn,
                pattern: pattern
              });
              EventBus.$emit("update-variant-view");
            }
            this.templateSyns.splice(this.templateSyns.findIndex((v) => v.name == this.selectedSyn.name), 1);
            this.selectedSyn = null;
            this.$store.state.unsavedChanges = true;
            this.selectedSyn = this.templateSyns[this.templateSyns.length - 1];
          }
        },
        { width: 310, height: "auto", adaptive: true }
      );
    },

    onRenameSynonym() {
      this.newName = this.selectedSyn.name;
      this.renaming = true;
      this.$nextTick(() => {
        this.$refs.editName.focus();
      });
    },

    renameSynonym() {
      if (this.newName !== this.selectedSyn.name) {
        const query = this.selectedSyn.name;
        const replacement = this.newName;
        const pattern = this.synonymPattern(query);
        this.$store.commit("replaceTextByRegex", { query: query, replacement: replacement, pattern: pattern });
        if (this.$store.state.sentenceBeingEdited) {
          this.$store.commit("replaceTextByRegexInCurrentSection", {
            query: query,
            replacement: replacement,
            pattern: pattern
          });
          EventBus.$emit("update-variant-view");
        }
        const synData = {
          synonymName: this.selectedSyn.name,
          newName: this.newName
        };
        this.$store.commit("renameTemplateSynonym", synData);
        this.$store.state.unsavedChanges = true;
      }
      this.renaming = false;
      this.newName = null;
    },

    updatePreview() {
      this.$store
        .dispatch("getTemplatePreview", {
          template: this.$store.state.template,
          variables: this.$store.state.templateVariables
        })
        .then((preview) => {
          // this.$store.state.templatePreview = preview;
          this.$store.commit("setTemplatePreview", preview);
        });
    },
    searchTemplate() {
      const pattern = this.synonymPattern(this.selectedSyn.name);
      this.matchCounter = 0;
      let matches = this.template.searchByRegex(pattern);
      matches.forEach((match) => {
        const matchesInVariant = match.text.match(pattern);
        this.matchCounter = this.matchCounter + (matchesInVariant ? matchesInVariant.length : 0);
      });
    }
  },
  computed: {
    templateSyns() {
      return this.$store.state.template.globalSynonyms || [];
    },
    invalidName() {
      let synonymName = this.renaming ? this.newName : this.newTemplateSyn;
      return this.templateSyns.some((syn) => syn.name == synonymName);
    },

    nameIsSelf() {
      return this.newName == this.selectedSyn.name;
    },

    invalidChars() {
      let synonymName = this.renaming ? this.newName : this.newTemplateSyn;

      return synonymName !== "" ? /^[ÆØÅæøå"'a-z0-9\-\\ ]+$/i.test(synonymName) : true;
    },
    filteredSynonymList() {
      return orderBy(
        this.templateSyns.filter((syn) => syn.name.toLowerCase().includes(this.searchFilter.toLowerCase())),
        [(syn) => syn.name.toLowerCase()],
        ["asc"]
      );
    }
  },
  mounted() {
    if (this.templateSyns) {
      this.selectedSyn = this.templateSyns[0];
    }
    if (!this.selectedSyn) {
      this.createSynClicked = true;
    }
  },
  watch: {
    selectedSyn: {
      handler: function(val, oldVal) {
        this.renaming = false;
        this.newName = null;
        this.hasChanges = false;
        this.synonymsTranslated = false;
      }
    }
  },
  components: {
    CustomPopover,
    CustomInput
  }
};
</script>

<style lang="less">
.template-syns-popover {
  width: 840px;
  // height: 500px;
  line-height: 1.5;
  background-color: #fff;
  position: absolute;
  color: #3d464a;
  &.custom-popover {
    background-color: #fff;
    right: calc(50% - (840px / 2));
    left: unset;
    top: calc(50% - (500px / 2));
    &::before {
      // content: url(*/svg/close.svg);
      display: none;
    }
    .close-button {
      display: none;
    }
  }
  .popover-header {
    h2 {
      margin: 0;
      color: var(--charcoal);
    }
  }
  .create-btn {
    position: absolute;
    bottom: 0px;
    margin: 12px;
    width: max-content;
  }
  .template-syn {
    display: flex;
    align-items: center;
    padding: 5px 20px;
    > .syn-name {
      padding-right: 6px;
    }
    cursor: pointer;
    span {
      flex-grow: 1;
    }

    .duplicate-btn {
      opacity: 0;
      margin-right: 12px;
    }
    .selected-chevron {
      opacity: 0;
      font-size: 12px;
    }
    &:hover {
      background-color: rgba(219, 218, 218, 0.4);

      .duplicate-btn,
      .selected-chevron {
        opacity: 1;
      }
    }

    &.is-selected {
      background-color: rgba(219, 218, 218);
      .selected-chevron {
        opacity: 1;
      }
    }
  }

  .template-syns-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    background-color: #fff;
    height: 420px;
    border-radius: 0 0 10px 10px;
    .right {
      height: calc(100% - 10px);
      background-color: #fff;
      overflow: auto;
      border-radius: 0 0 10px 0;
    }
    .left {
      overflow: auto;
      height: calc(100% - 50px);
      .search-filter {
        position: relative;
        margin: 0 12px 12px 12px;
        .search-input {
          width: 100%;
          border: 0 none;
        }
        .search-icon {
          position: absolute;
          right: 20px;
          bottom: 8px;
          width: 13px;
        }
      }
    }
    .close-icon {
      position: absolute;
      right: 40px;
      top: 8px;
      width: 13px;
    }

    .create-template-syn {
      margin: 0 12px 12px 12px;
      button {
        margin-top: 12px;
        float: right;
      }
    }
  }

  .close-popover {
    color: var(--charcoal);
    cursor: pointer;
  }
  .hide {
    opacity: 0;
    pointer-events: none;
  }
  select option:disabled {
    color: red;
  }
  .no-syns {
    margin: 55px auto;
    text-align: center;
    font-size: 14px;
    display: flex;
    color: #8f979c;
    letter-spacing: 0.6px;
    span {
      margin: 0 auto;
    }
  }

  .template-synonym-list-wrapper {
    margin-bottom: 46px;
    width: 400px;
    color: #8f979c;
    > span {
      color: #8f979c;
      letter-spacing: 0.6px;
      margin: 12px 12px 6px 12px;
    }
    .template-synonym-list {
      position: relative;
      margin: 0 12px;
      .trash-synonym {
        position: absolute;
        top: 50%;
        right: 0px;
        border: none;
        background-color: transparent;
      }

      .custom-input {
        &.is-translating {
          filter: blur(2px);
          pointer-events: none;
        }
      }
    }

    .syn-instances-header {
      padding: 8px 12px;
      display: flex;
      justify-content: space-between;

      .actions {
        display: flex;
        gap: 4px;
        .btn-undo {
          box-shadow: unset;
          color: var(--charcoal);
        }
      }
    }
  }
  .selected-syn {
    & > div.top,
    div form {
      position: relative;
      display: grid;
      grid-template-columns: auto max-content;
      align-items: end;

      .delete-syn {
        cursor: pointer;
        position: absolute;
        right: 21px;
        top: 38px;
      }
      .rename-syn,
      .checkmark {
        cursor: pointer;
        position: absolute;
        right: 48px;
        top: 38px;
        padding: 0;
      }

      & > div.input-element {
        margin: 0 12px;
        &.disabled-name input {
          border-bottom: none;
        }
      }
    }

    h3 {
      margin: 12px 12px 0 12px;
    }
  }

  button.btn-ai, button.btn-undo {
    width: 20px;
    height: 20px;
    border-radius: 100px;
    font-size: 12px;
    background-color: #fff;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    color: #b47bff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    &:hover {
      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
    }
  }
  .new-synonym-form {
    padding: 0 12px;
    position: relative;
    padding-bottom: 24px;
    // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    .new-synonym {
      position: absolute;
      top: calc(50% - 12px);
      right: 16px;
      transition: 0.2s;
      font-size: 18px;
      font-weight: 400;
      color: rgb(117, 117, 117);
      border: none;
      background-color: transparent;
      &:focus {
        outline: 0 !important;
        color: var(--orange-web);
      }
    }
    .ai-synonyms {
      position: absolute;
      top: calc(50% - 8px);
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: var(--ai-primary);
      right: 38px;
      transition: 0.2s;
      border: none;
      background-color: transparent;
    }
    .input-element:focus-within + .new-synonym {
      color: var(--orange-web);
    }

    .input-element input::-webkit-input-placeholder {
      width: 365px;
    }
  }

  .rename-form {
    span {
      position: absolute;
      bottom: -14px;
      left: 12px;
    }
  }
  .active-input {
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15);
    background: #fafafa;
    transition: 0.2s;
    transform: scale(1.01);
  }
}
</style>
